import { render, staticRenderFns } from "./OrdersUnavailable.vue?vue&type=template&id=aca48388&"
import script from "./OrdersUnavailable.vue?vue&type=script&lang=js&"
export * from "./OrdersUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./OrdersUnavailable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports